import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/star/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-90abe52a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-bar" }
const _hoisted_2 = { class: "buttons-container" }
const _hoisted_3 = {
  key: 1,
  class: "footer-btn-skeleton square-footer-btn",
  "aria-hidden": "true"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存策略")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除策略")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("订阅信号")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消订阅")
const _hoisted_8 = { class: "modal-content-wrapper" }
const _hoisted_9 = { class: "star-dialog-header" }
const _hoisted_10 = { class: "star-dialog-title" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "star-dialog-logo"
}, null, -1))
const _hoisted_12 = { class: "modal-body" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "priority-label" }, "策略选择", -1))
const _hoisted_14 = {
  key: 1,
  class: "error-text-container"
}
const _hoisted_15 = { class: "error-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 上述策略仅在对应回测区间内有效，不构成投资建议或收益承诺。请投资者审慎决策、理性投资，自主承担投资风险。 ", -1))
const _hoisted_17 = { class: "confirm-modal-body" }
const _hoisted_18 = { class: "confirm-title" }
const _hoisted_19 = { class: "confirm-btns" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_22 = { class: "confirm-modal-body" }
const _hoisted_23 = { class: "confirm-title" }
const _hoisted_24 = { class: "confirm-countdown" }

import { ref, reactive, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import { strategyAction } from '@/api/starresultApi'
import store from '@/store/index'
import { useStarTip } from '@/utils/useStarTip'
import { useStarActivation, queryStarActivationStatus } from '@/utils/useStarActivation'
import { useStarRouter } from '@/utils/useStarTheme'
import StarTipDialog from '@/components/star/StarTipDialog.vue'
import StarActivationDialog from '@/components/star/StarActivationDialog.vue'
import type { TemplateLockState } from '@/utils/useStarTemplateLock'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionFooter',
  props: {
    isDark: { type: Boolean },
    aiPriority: null,
    strategyDetails: null,
    squareTemplate: { type: Boolean },
    templateLockState: null
  },
  emits: ["refresh", "unlock"],
  setup(__props: any, { expose, emit }: { emit: ({ (e: 'refresh'): void; (e: 'unlock'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isDark: boolean
  aiPriority?: number
  strategyDetails?: Record<string, any>
  /** 模版策略详情：底部仅展示复制/解锁按钮 */
  squareTemplate?: boolean
  templateLockState?: TemplateLockState
}





const route = useRoute()
const { starPush } = useStarRouter()
// 从 strategyDetails 对象中取各字段，避免响应式丢失问题
const pageType = computed(() => Number(props.strategyDetails?.pageType))
const isSubscribed = computed(() => props.strategyDetails?.isSubscribed === true)
const strategyTitle = computed(() => props.strategyDetails?.title)
 const strategyNamereq = computed(() => props.strategyDetails?.comResult?.req?.strategyName)
const quantType = computed(() => props.strategyDetails?.quantType)
const visible = ref(false)
const mode = ref<'save' | 'subscribe'>('save')
const strategyName = ref('')
const selectedPriority = ref<number | undefined>(1)

const errorMessages = ref<string[]>([])
const selectError = ref('')
const inputErrors = computed(() => errorMessages.value)
const loadingMap = reactive({ save: false, del: false, sub: false, unsub: false })

const confirmConfig = reactive<{
  visible: boolean
  title: string
  loading: boolean
  onOk: () => void
}>({
  visible: false,
  title: '',
  loading: false,
  onOk: () => { },
})
const deleteCountdown = ref(0)
const successMessage = ref('')
let deleteTimer: ReturnType<typeof setInterval> | null = null

const {
  tipDialog, unlock, handleBacktestStatus, showUnlockDialog,
  handleUnlockClose, handleUnlockBannerClick, handleUnlockShareClose, handleUnlockPromoClose,
  handleUnlockPurchaseClick,
} = useStarTip()
const {
  showActivationDialog,
  showActivationQr,
  openActivationQr,
  refreshActivation,
  hideActivation,
} = useStarActivation()

const starUserName = computed(
  () => store.state.userInfo?.username || store.state.userInfo?.userName || ''
)

const priorityOptions = [
  { value: 1, label: '进取型' },
  { value: 2, label: '稳健型' },
  { value: 3, label: '均衡型' },
]

const openModal = async (m: 'save' | 'subscribe') => {
  mode.value = m
  // 自动填充：title + 今天日期（格式 YYYYMMDD）
  const today = new Date()
  const dateStr = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`
  strategyName.value = strategyNamereq.value ? `${strategyNamereq.value}` :  `${strategyTitle.value}${dateStr}`
  errorMessages.value = []
  selectError.value = ''
  selectedPriority.value = props.aiPriority || 1
  visible.value = true
}

const handleInput = () => {
  if (strategyName.value.length > 50) {
    strategyName.value = strategyName.value.slice(0, 50)
  }
  if (errorMessages.value.length > 0) {
    errorMessages.value = []
  }
}

function has123(input: any) {
  const s = String(input);
  return s.includes('1') || s.includes('2') || s.includes('3');
}

/** 保存/订阅 strategyAction 返回 status，与 handleBacktestStatus 保持一致 */
const handleStrategyActionStatus = (
  status: number | undefined,
  toast: string | undefined,
  options: {
    /** 弹窗保存时 status=2 展示内联「名称已存在」 */
    inlineNameDuplicate?: boolean
    onSuccess: () => void
  }
) => {
  if (status == 2 && options.inlineNameDuplicate) {
    errorMessages.value.push('该策略名称已存在，请重新输入')
    return
  }
  if (status === 1) {
    options.onSuccess()
    return
  }
  visible.value = false
  void handleBacktestStatus(status ?? 0, toast, options.onSuccess, starUserName.value)
}

// Task 3.1: 订阅信号 - isfrom=1 弹窗订阅并保存，isfrom=2 直接订阅
const handleSub = async () => {
  const isfrom = route.query.isfrom as string
  if (isfrom === '1') {
    // 弹窗，走 subsave 逻辑
    openModal('subscribe')
    emit('refresh')
    return
  }
  // isfrom=2 或默认：直接订阅
  loadingMap.sub = true
  const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || store.state.loginInfo.token
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
  try {
    const res: any = await strategyAction({
      data: { taskID, action: 'sub' },
      headers: { token, username },
    })
    handleStrategyActionStatus(res.data?.status, res.data?.toast, {
      onSuccess: () => {
        message.success(res.data?.toast || '订阅成功')
        emit('refresh')
      },
    })
  } catch (error: any) {
    message.error(error.message || '网络请求失败')
  } finally {
    loadingMap.sub = false
  }
}

// Task 4.2: 取消订阅 - 先弹确认弹窗
const handleUnsub = () => {
  confirmConfig.title = '您确定要取消订阅吗？'
  confirmConfig.loading = false
  confirmConfig.onOk = async () => {
    confirmConfig.loading = true
    const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
    const token = (route.query.token as string) || store.state.loginInfo.token
    const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
    loadingMap.unsub = true
    try {
      await strategyAction({
        data: { taskID, action: 'unsub' },
        headers: { token, username },
      })
      confirmConfig.visible = false
      emit('refresh')
    } catch (error: any) {
      message.error(error.message || '网络请求失败')
    } finally {
      confirmConfig.loading = false
      loadingMap.unsub = false
    }
  }
  confirmConfig.visible = true
}

// Task 5.1: 删除策略 - 先弹确认弹窗，成功后倒计时跳首页
const handleDel = () => {
  confirmConfig.title = '您确定要删除该策略吗？'
  confirmConfig.loading = false
  confirmConfig.onOk = async () => {
    confirmConfig.loading = true
    const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
    const token = (route.query.token as string) || store.state.loginInfo.token
    const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'
    loadingMap.del = true
    try {
      await strategyAction({
        data: { taskID, action: 'del' },
        headers: { token, username },
      })
      confirmConfig.visible = false
      successMessage.value = '删除成功'
      deleteCountdown.value = 3
      deleteTimer = setInterval(() => {
        deleteCountdown.value--
        if (deleteCountdown.value <= 0) {
          clearInterval(deleteTimer!)
          deleteTimer = null
          starPush('/star')
        }
      }, 1000)
    } catch (error: any) {
      message.error(error.message || '网络请求失败')
    } finally {
      confirmConfig.loading = false
      loadingMap.del = false
    }
  }
  confirmConfig.visible = true
}

const handleConfirm = async () => {
  if (!strategyName.value || loadingMap.save) return

  // 显示了优先级选择器时必须选择
  if ((has123(props.aiPriority) || quantType.value == 2) && selectedPriority.value == null) {
    selectError.value = '请选择策略优先级'
    return
  }
  selectError.value = ''

  loadingMap.save = true
  errorMessages.value = []
  const taskID = (route.query.taskID as string) || '019d3c6bcbfe7a43b2f2b5662d5e58a8_custom_dotest'
  const token = (route.query.token as string) || store.state.loginInfo.token
  const username = store.state.userInfo?.username || 'fb5b4492954a4ab3b19d16a4edbb0ecb'

  try {
    const actionParam = mode.value === 'save' ? 'save' : 'subsave'

    const res: any = await strategyAction({
      data: {
        taskID,
        action: actionParam,
        name: strategyName.value,
        ...(has123(props.aiPriority) || quantType.value == 2 ? { aiPriority: selectedPriority.value } : {}),
      },
      headers: {
        token,
        username,
      },
    })

    handleStrategyActionStatus(res.data?.status, res.data?.toast, {
      inlineNameDuplicate: true,
      onSuccess: () => {
        visible.value = false
        successMessage.value = mode.value === 'subscribe' ? '策略保存成功，你将收到信号推送' : '策略保存成功'
        deleteCountdown.value = 3
        deleteTimer = setInterval(() => {
          deleteCountdown.value--
          if (deleteCountdown.value <= 0) {
            clearInterval(deleteTimer!)
            deleteTimer = null
            starPush('/star')
          }
        }, 1000)
      },
    })
  } catch (error: any) {
    message.error(error.message || '网络请求失败')
  } finally {
    loadingMap.save = false
  }
}

onUnmounted(() => {
  if (deleteTimer) clearInterval(deleteTimer)
})

/** 模板解锁：先查激活订单，有则弹激活框；无或查询失败则弹 0 元解锁框 */
const handleUnlockFlow = async () => {
  const result = await queryStarActivationStatus(route, starUserName.value)
  if (result.success && result.hasUnactivatedOrder) {
    showActivationQr.value = false
    showActivationDialog.value = true
    return
  }
  hideActivation()
  await showUnlockDialog()
}

/** 模版策略详情：复制策略 / 解锁策略 */
const handleSquareFooterClick = () => {
  if (props.templateLockState === 'locked') {
    emit('unlock')
    return
  }
  const taskID = (route.query.taskID as string) || ''
  if (!taskID) return
  starPush('/star/group', { watchWord: taskID })
}

expose({ showUnlockDialog: handleUnlockFlow })

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "action-footer-container",
    style: _normalizeStyle({ backgroundColor: !__props.isDark ? '#ffffff' : '#1A1A1A' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.squareTemplate && __props.templateLockState !== 'pending')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "action-btn subscribe-btn square-footer-btn",
              onClick: handleSquareFooterClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.templateLockState === 'locked' ? '解锁策略' : '复制策略选股因子'), 1)
              ]),
              _: 1
            }))
          : (__props.squareTemplate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_unref(pageType) == 1)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "action-btn save-btn",
                      loading: loadingMap.save,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal('save')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_unref(pageType) == 2)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        class: "action-btn gray-btn",
                        loading: loadingMap.del,
                        onClick: handleDel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["loading"]))
                    : _createCommentVNode("", true),
                (!_unref(isSubscribed))
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 2,
                      class: "action-btn subscribe-btn",
                      loading: loadingMap.sub,
                      onClick: handleSub
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : (_openBlock(), _createBlock(_component_a_button, {
                      key: 3,
                      class: "action-btn gray-btn",
                      loading: loadingMap.unsub,
                      onClick: handleUnsub
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["loading"]))
              ], 64))
      ])
    ]),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((visible).value = $event)),
      title: null,
      footer: null,
      closable: false,
      width: "360px",
      wrapClassName: 'star-action-modal',
      destroyOnClose: "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(mode.value === 'save' ? '保存策略' : '订阅信号'), 1)
            ]),
            _createElementVNode("span", {
              class: "star-dialog-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = false))
            }, "✕")
          ]),
          _createElementVNode("div", _hoisted_12, [
            (has123(__props.aiPriority) || _unref(quantType) == 2)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["priority-select-container", { 'has-error': !!selectError.value }])
                }, [
                  _hoisted_13,
                  _createVNode(_component_a_select, {
                    value: selectedPriority.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((selectedPriority).value = $event)),
                    placeholder: "请选择",
                    class: "priority-select",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (selectError.value = ''))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(priorityOptions, (opt) => {
                        return _createVNode(_component_a_select_option, {
                          key: opt.value,
                          value: opt.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(opt.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ], 2))
              : _createCommentVNode("", true),
            (selectError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(selectError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["input-container", { 'has-error': _unref(inputErrors).length > 0 }])
            }, [
              _createVNode(_component_a_textarea, {
                value: strategyName.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((strategyName).value = $event)),
                placeholder: "请输入策略名称...",
                class: "custom-input",
                maxlength: 50,
                "auto-size": { minRows: 2, maxRows: 4 },
                onInput: handleInput
              }, null, 8, ["value"])
            ], 2),
            _createElementVNode("div", {
              class: "error-text-container",
              style: _normalizeStyle({ visibility: _unref(inputErrors).length > 0 ? 'visible' : 'hidden' })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(inputErrors), (msg, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "error-text",
                  key: idx
                }, _toDisplayString(msg), 1))
              }), 128))
            ], 4),
            _hoisted_16,
            _createVNode(_component_a_button, {
              class: _normalizeClass(["confirm-btn", { 'is-disabled': !strategyName.value || loadingMap.save }]),
              loading: loadingMap.save,
              onClick: handleConfirm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(mode.value === 'save' ? '确定' : '保存并订阅信号'), 1)
              ]),
              _: 1
            }, 8, ["class", "loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: confirmConfig.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((confirmConfig.visible) = $event)),
      title: null,
      footer: null,
      closable: false,
      width: "320px",
      wrapClassName: 'star-confirm-modal',
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(confirmConfig.title), 1),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_button, {
              class: "confirm-cancel-btn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmConfig.visible = false))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "confirm-ok-btn",
              loading: confirmConfig.loading,
              onClick: confirmConfig.onOk
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (deleteCountdown.value > 0)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: true,
          title: null,
          footer: null,
          closable: false,
          width: "320px",
          wrapClassName: 'star-confirm-modal',
          centered: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", _hoisted_23, _toDisplayString(successMessage.value), 1),
              _createElementVNode("p", _hoisted_24, _toDisplayString(deleteCountdown.value) + " 秒后返回首页", 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.squareTemplate)
      ? (_openBlock(), _createBlock(StarTipDialog, {
          key: 1,
          tipDialog: _unref(tipDialog),
          unlock: _unref(unlock),
          onUnlockClose: _unref(handleUnlockClose),
          onUnlockBannerClick: _unref(handleUnlockBannerClick),
          onUnlockShareClose: _unref(handleUnlockShareClose),
          onUnlockPromoClose: _unref(handleUnlockPromoClose),
          onUnlockPurchaseClick: _unref(handleUnlockPurchaseClick)
        }, null, 8, ["tipDialog", "unlock", "onUnlockClose", "onUnlockBannerClick", "onUnlockShareClose", "onUnlockPromoClose", "onUnlockPurchaseClick"]))
      : _createCommentVNode("", true),
    (!__props.squareTemplate)
      ? (_openBlock(), _createBlock(StarActivationDialog, {
          key: 2,
          visible: _unref(showActivationDialog),
          "show-qr": _unref(showActivationQr),
          onActivate: _unref(openActivationQr),
          onRefresh: _cache[8] || (_cache[8] = () => _unref(refreshActivation)(_unref(route), _unref(starUserName))),
          onClose: _unref(hideActivation)
        }, null, 8, ["visible", "show-qr", "onActivate", "onClose"]))
      : _createCommentVNode("", true)
  ], 4))
}
}

})